import { render, staticRenderFns } from "./TagsEditSelector.vue?vue&type=template&id=7f296a9b&scoped=true&"
import script from "./TagsEditSelector.vue?vue&type=script&lang=js&"
export * from "./TagsEditSelector.vue?vue&type=script&lang=js&"
import style0 from "./TagsEditSelector.vue?vue&type=style&index=0&id=7f296a9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f296a9b",
  null
  
)

export default component.exports